export const environment = {
  production: true,
  cognito: {
    userPoolId: 'af-south-1_mtf7XOJzd',
    userPoolWebClientId: '35ac7pdvi1qpju9hvroehi96gq',
    userPoolClientId: '35ac7pdvi1qpju9hvroehi96gq',
    region: 'af-south-1',
    oauth: {
      domain: 'af-south-1mtf7xojzd.auth.af-south-1.amazoncognito.com',
      scope: [
        'email',
        'openid',
        'profile',
        // 'aws.cognito.signin.user.admin',
        'phone'
      ],
      redirectSignIn: 'https://web-staging.precisiongateway.co.za/mapping',
      redirectSignOut: 'https://web-staging.precisiongateway.co.za/',
      responseType: 'code'
    }
  },
  apiBaseUrl: "https://api-staging.precisiongateway.co.za/v2/",
  apiBaseUrlV4: "https://admin-staging.precisiongateway.co.za/v4/",
  otcBaseUrl: "",
  apiAdminBaseUrl: "https://admin-staging.precisiongateway.co.za/",
  allowedAuthHeaders: ['https://api-staging.precisiongateway.co.za', 'https://admin-staging.precisiongateway.co.za'],
  allowedCustomHeaders: ['https://api-staging.precisiongateway.co.za/v2/communication/terms', 'https://admin-staging.precisiongateway.co.za', 'https://api-staging.precisiongateway.co.za/v2/pin-management', 'https://admin-staging.precisiongateway.co.za/v4/season-management'],
  replaceAgentHeaders: [''],
  ignoreReplaceAgentHeaders: [''],
  submissionApproval: null,
  termsAndConditionsUrl: 'https://precisiongateway.co.za/terms-and-conditions/',
  privacyPolicyUrl: 'https://precisiongateway.co.za/privacy-policy/',
  publicFacingUrl: 'https://precisiongateway.co.za/',
  representatives: {},
  google: {
    analyticsTag: '',
    mapConfig: {
      polygonStrokeColour: '#000000',
      polygonEditingStrokeColour: '#FFFFFF',
      polygonHoverColor: '#E2703A',
      griddingRedStrokeColour: '#FF0000',
      griddingYellowStrokeColour: '#FFD500',
      griddingGreenStrokeColour: '#00B47D',
    }
  },
    theme: { 
      title: 'SGS Precision Gateway',
      welcomeTitle: 'Welcome to Precision Gateway',
      logo: './assets/img/precision_gateway_logo.png',
      navBarlogo: './assets/img/precision_gateway_logo.png',
      compactLogo: './assets/img/precision_gateway_logo.png',
      favicon: 'assets/precision_gateway_favicon.png',
      spinnerColor: '#E2703B',
      themeColourScheme: ["#C8C8D2", "#FFFFFF", "#C8C8D2", "#64646E", "#E2703A", "#E2703A", "#999999", "#E2703A", "#E2703A", "#00000029", "#E2703A", "#000000", "#FFFFFF", "#E2703A", "#F2F2F9", "#000000", "#000000", "#999999", "#00B47D", "#FFD500", "#FF0000", "#333333", "#E2703A", "#64646E", "#999999", "#FFFFFF", "#FFFFFF", "#00B47D", "#E2703A", "#333333"],
      logoStyling: {
        width: 'auto',
        height: '50px',
        paddingBottom: '10px',
        paddingTop: '10px',
        marginBottom: '20px',
        marginTop: '20px',
        display: 'flex'
      },
      navBarlogoStyling: {
        maxWidth: '65%',
        maxHeight: '65%'
      },
      background: {
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        backgroundRepeat:'no-repeat',
        backgroundSize:'cover',
        backgroundImage: 'url("/assets/precision_gateway_public_background.png")'
      }
  },
  firebase: {
    apiKey: "AIzaSyBVCaBsrw2BnFqEht735Ue4MRnfDG1qa4s",
    authDomain: "precision-gateway-staging-vc.firebaseapp.com",
    databaseURL: "https://precision-gateway-staging-vc-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "precision-gateway-staging-vc",
    storageBucket: "precision-gateway-staging-vc.appspot.com",
    messagingSenderId: "304185904746",
    appId: "1:304185904746:web:a3c7c1eef3985e6e3d8413",
    measurementId: "G-DKBT0CJC9E"
  },
  reCaptcha:{
    siteKey: "6Ldt9conAAAAAEtnHYSUnMKyTQXw2J5CrgVgxSP3",
  },
  firebaseToken: {
    FIREBASE_APPCHECK_DEBUG_TOKEN: false,
  },
  unleash: {
    url: 'https://unleash-staging.precisiongateway.co.za/api/frontend',
    clientKey: '*:development.c9bd1c40e3be5fe9bec9a57b70958dfa7b4dcc98c31e1561326ee5d3',
    appName: 'web.precisiongateway.co.za'
  },
  soilIqUrl: 'https://soil-iq-staging.precisiongateway.co.za'
};
